/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CharityPaymentIntentResponseDto = {
    /**
     * The UUID of the payment intent
     */
    id: string;
    /**
     * The UUID of the charity
     */
    charity_id: string;
    /**
     * Payment amount in dollars
     */
    amount: number;
    /**
     * Currency code
     */
    currency: string;
    /**
     * Payment status
     */
    status: CharityPaymentIntentResponseDto.status;
    /**
     * Purpose of the payment
     */
    purpose: string;
    /**
     * Stripe session ID for payment processing
     */
    stripe_session_id: string;
    /**
     * Stripe checkout session URL for redirecting user to payment
     */
    checkout_url: string;
};
export namespace CharityPaymentIntentResponseDto {
    /**
     * Payment status
     */
    export enum status {
        PENDING = 'PENDING',
        POSTED = 'POSTED',
        CANCELED = 'CANCELED',
    }
}

